import { pessoaModel } from '@/models/pessoa'

export const acionadoModel = {
  acionado: function () {
    return {
      id: '',
      ds_obervacao: '',
      pessoa_id: '',
      tipoacionado_id: '',
      pessoa: new pessoaModel.pessoa(),
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Acionado/_model/acionado.js